module.exports = __webpack_public_path__ + "media/images/mermaid-3089ddd00da99073c10eb99d60f5efca.png";